import React from 'react';
import { useCompanyLogo } from '../../hooks/useCompanyLogo';

interface CompanyLogoProps {
  name: string;
  website: string;
  existingLogo?: string;
  className?: string;
}

const CompanyLogo: React.FC<CompanyLogoProps> = ({ 
  name, 
  website, 
  existingLogo,
  className = "w-[16px] h-[16px]"
}) => {
  const { logoUrl, loading, error } = useCompanyLogo(name, website, existingLogo);

  // Generate initials
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  // If we have a logo URL and it's valid
  if (logoUrl && !error) {
    return (
      <div className={`${className} relative`}>
        <img 
          src={logoUrl}
          alt={`${name} logo`}
          className={`w-full h-full rounded-[8px] object-cover`}
          onError={(e) => {
            e.currentTarget.style.display = 'none';
            e.currentTarget.parentElement?.querySelector('.initials-fallback')?.classList.remove('hidden');
          }}
        />
        <div className={`initials-fallback hidden ${className} rounded-[4px] bg-[#F0F6FF] flex items-center justify-center`}>
          <span className="text-[#3F64B6] text-[12px] font-normal">{getInitials(name)}</span>
        </div>
      </div>
    );
  }

  // Show initials as fallback
  return (
    <div className={`${className} rounded-[4px] bg-[#F0F6FF] flex items-center justify-center`}>
      <span className="text-[#3F64B6] text-[12px] font-normal">{getInitials(name)}</span>
    </div>
  );
};

export default CompanyLogo; 